<template>
  <div class="row loading-panel">
    <b-spinner variant="primary"></b-spinner>
  </div>
</template>
<script>
export default {};
</script>
<style>
.loading-panel {
  min-height: 200px;
  display: flex;
  align-items: center;
}
</style>
